import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../services/axios-client"
import { useNavigate } from "react-router-dom"

const useNavbarSidebar = () => {
    const [selectedUser, setSelectedUser] = useState()
    const [employeeSelect, setEmployeeSelect] = useState()
    const [userValue, setUserValue] = useState()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const getAllUsers = async() => {
        try {
            setLoading(true)
            let res = await axiosInstance.get('/auth/users/all')
            if (res.status===200) {
                let data = {}
                setEmployeeSelect([])
                for (const user of res.data.data) {
                    setEmployeeSelect((prev) => [...prev,{
                        'label':user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName,
                        'value':user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName
                    }])
                    data[user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName] = user.ID
                }
                setUserValue(data)
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setLoading(false)
        }
    }

    const getAllUsersAdmin = async() => {
        try {
            setLoading(true)
            let res = await axiosInstance.get('/auth/users/all-admin')
            if (res.status===200) {
                let data = {}
                setEmployeeSelect([])
                for (const user of res.data.data) {
                    setEmployeeSelect((prev) => [...prev,{
                        'label':user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName,
                        'value':user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName
                    }])
                    data[user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName] = user.ID
                }
                setUserValue(data)

            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setLoading(false)
        }
    }

    const getAllUsersSpmoHandle = async(id) => {
        try {
            setLoading(true)
            let res = await axiosInstance.get(`/auth/calibrations/spmo-user/${id}`)
            if (res.status===200) {
                let data = {}
                setEmployeeSelect([])
                for (const user of res.data.data) {
                    setEmployeeSelect((prev) => [...prev,{
                        'label':user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName,
                        'value':user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName
                    }])
                    data[user.Nik+ " "+user.Name + " " + user.Division + " - " + user.BusinessUnitName] = user.ID
                }
                setUserValue(data)
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setLoading(false)
        }
    }

    const getUser = async(id) => {
        try {
            let res = await axiosInstance.get(`/auth/users-switch/${id}`)
            if (res.status===200) {
                setSelectedUser(res.data.data.Nik+ " "+res.data.data.Name +" "+ res.data.data.Division + " - " + res.data.data.BusinessUnit.Name)
            }
            
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    const switchUser = async (value, user) => {
        try {
            let data
            if (value) {
                data = userValue[value]
            }else{
                if (user) {
                    data = user.ID
                }
            }

            let res = await axiosInstance.get(`/auth/users-switch/${data}`)
            if (res.status===200) {
                if (user) {
                    // console.log(user)
                }
                localStorage.setItem("user", JSON.stringify({
                    ...user,
                    SwitchUser: {
                        Email: res.data.data.Email,
                        ID: res.data.data.ID,
                        Name: res.data.data.Name,
                        Role: res.data.data.Role,
                        Username: res.data.data.Username
                    }
                }));
                toast.success("Successfully switch User")
                setTimeout(() => {
                    navigate('/home')
                    window.location.reload()
                }, 1000)
            }
            
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    return{
        getAllUsers,
        getAllUsersAdmin,
        getAllUsersSpmoHandle,
        employeeSelect,
        selectedUser,
        setSelectedUser,
        getUser,
        switchUser,
        loading
    }
}

export default useNavbarSidebar